import React from 'react';
import DataStore from '../flux/stores/DataStore.js';
import Layout from './layout.js';
import {Link} from 'react-router-dom';
import Footer from './footer.js';
import {parseDate} from './helper-lib.js';
import Underliner from './underliner.js';

class Post extends React.Component {
  cleanPath(path) {
    let newPath = path.substr(6);
    return newPath;
  }

  render() {
    let post = DataStore.getPostBySlug(this.cleanPath(this.props.location.pathname));

    return (
      <div>
        <Layout>
          <section className="post-content">
            <div className="cnt">
              <div className="thumb-cnt">
                <div className="thumb">
                  {post.acf.image !== null && post.acf.image !== undefined && post.acf.image ?
                    <img src={post.acf.image.url} alt={post.acf.image.title} />:null
                  }
                </div>
                <Underliner className="back-to-news">
                  <Link to='/news'>Back to News</Link>
                </Underliner>

                <div className="cross left top"><span className="vert"></span><span className="horiz"></span></div>
                <div className="cross left bottom"><span className="vert"></span><span className="horiz"></span></div>
                <div className="cross right top"><span className="vert"></span><span className="horiz"></span></div>
                <div className="cross right bottom"><span className="vert"></span><span className="horiz"></span></div>
              </div>
              <div className="details">
                <div className="date">{parseDate(post.date)}</div>
                <div className="title" dangerouslySetInnerHTML={{__html:post.title.rendered}} />

                <div className="cross left top"><span className="vert"></span><span className="horiz"></span></div>
                <div className="cross left bottom"><span className="vert"></span><span className="horiz"></span></div>
                <div className="cross right top"><span className="vert"></span><span className="horiz"></span></div>
                <div className="cross right bottom"><span className="vert"></span><span className="horiz"></span></div>
              </div>
              <div className="content-cnt">
                <div className="content-inner" dangerouslySetInnerHTML={{__html:post.content.rendered}} />
                <Underliner className="back-to-news-mobile">
                  <Link to='/news'>Back to News</Link>
                </Underliner>
                <div className="cross left top"><span className="vert"></span><span className="horiz"></span></div>
                <div className="cross left bottom"><span className="vert"></span><span className="horiz"></span></div>
                <div className="cross right top"><span className="vert"></span><span className="horiz"></span></div>
                <div className="cross right bottom"><span className="vert"></span><span className="horiz"></span></div>
              </div>
            </div>
          </section>
        </Layout>
        <Footer footerClass="post" />
      </div>
    );
  }
}

export default Post;



// WEBPACK FOOTER //
// ./src/scripts/components/post.js